import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPeopleOnboarding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M18.116 8.997 21 11.852l-2.884 2.856m2.511-2.856H15.82m-6.618 3.07c-3.345 0-6.202.505-6.202 2.53S5.84 20 9.202 20c3.346 0 6.203-.506 6.203-2.53s-2.84-2.548-6.203-2.548m0-2.797c2.284 0 4.135-1.819 4.135-4.063S11.486 4 9.202 4 5.067 5.819 5.067 8.062c-.008 2.236 1.83 4.055 4.107 4.063z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPeopleOnboarding;
